import React from 'react';
import PropTypes from 'prop-types';
import HoverMenu from './hover-menu/hover-menu';
import HoverMenuItem from './hover-menu/hover-menu-item';
import HoverMenuItemSeparator from './hover-menu/hover-menu-separator';
import { getMenuGaAttributes } from './site-header.analytics.js';
import { useTranslator, useUrlLocalizer } from 'tradera-lang/translate';
import PenIcon from '@tradera/blueprint/theme/icons2/pen.svg?jsx';
import WriteIcon from '@tradera/blueprint/theme/icons2/write.svg?jsx';
import SaleIcon from '@tradera/blueprint/theme/icons2/sale.svg?jsx';
import ListIcon from '@tradera/blueprint/theme/icons2/list.svg?jsx';
import PackageIcon from '@tradera/blueprint/theme/icons2/package.svg?jsx';
import RatingPositiveIcon from '@tradera/blueprint/theme/icons2/rating-positive.svg?jsx';
import SoldIcon from '@tradera/blueprint/theme/icons2/sold.svg?jsx';
import UnsoldIcon from '@tradera/blueprint/theme/icons2/unsold.svg?jsx';
import { useIsFeatureEnabled } from 'tradera-hooks/use-is-feature-enabled';

const getGaAttributes = label =>
    getMenuGaAttributes('Top navigation', 'Selling menu', label);

const SellMenu = ({ showMenu }) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    const isTraderaShopEnabled = useIsFeatureEnabled('tradera-shop');
    return (
        <HoverMenu showMenu={showMenu} className="hover-sell-menu">
            <HoverMenuItem
                label={t('siteHeader_createItem')}
                link={toLocalizedUrl('/selling')}
                icon={<PenIcon className="icon" />}
                gaAttributes={getGaAttributes('Create new listing')}
            />
            <HoverMenuItem
                label={t('siteHeader_templates')}
                link={toLocalizedUrl('/selling/templates')}
                icon={<WriteIcon className="icon" />}
                gaAttributes={getGaAttributes('Listing templates')}
            />
            <HoverMenuItemSeparator />
            <HoverMenuItem
                label={t('siteHeader_activeItems')}
                link={toLocalizedUrl('/my/active')}
                icon={<SaleIcon className="icon" />}
                gaAttributes={getGaAttributes('Active listings')}
            />
            <HoverMenuItem
                label={t('siteHeader_soldItems')}
                link={toLocalizedUrl('/my/sold')}
                icon={<SoldIcon className="icon" />}
                gaAttributes={getGaAttributes('Sold listings')}
            />
            <HoverMenuItem
                label={t('siteHeader_unsoldItems')}
                link={toLocalizedUrl('/my/unsold')}
                icon={<UnsoldIcon className="icon" />}
                gaAttributes={getGaAttributes('Unsold listings')}
            />
            <HoverMenuItem
                label={t('siteHeader_picklist')}
                link={toLocalizedUrl('/my/sold/picklist')}
                icon={<ListIcon className="icon" />}
                gaAttributes={getGaAttributes('Picklist')}
            />
            <HoverMenuItemSeparator />
            <HoverMenuItem
                label={t('siteHeader_rateBuyer')}
                link={toLocalizedUrl(
                    '/my/leave-feedback/seller?transactionId=0'
                )}
                icon={<RatingPositiveIcon className="icon" />}
                gaAttributes={getGaAttributes('Rate buyer')}
            />
            {isTraderaShopEnabled && (
                <>
                    <HoverMenuItemSeparator />
                    <HoverMenuItem
                        label={t('siteHeader_buyShippingBags')}
                        link={toLocalizedUrl('/tradera-shop/shipping-bags')}
                        icon={<PackageIcon className="icon" />}
                        gaAttributes={getGaAttributes('Buy shipping bags')}
                    />
                </>
            )}
        </HoverMenu>
    );
};

SellMenu.propTypes = {
    showMenu: PropTypes.bool
};

export default SellMenu;
